import { useSelector } from 'react-redux'

import { useTargetDate } from './useTargetDate'
import { getAuthUserId } from '../../../data/auth/authSelectors'
import { RTKQueryHook, RTKQueryResultType } from '../../../data/baseApi'
import { useGetAppointmentUtilizationQuery } from '../../clients/clientDetails/data/utilizationApi'

export const useAppointmentUtilizationData: RTKQueryHook<typeof useGetAppointmentUtilizationQuery> = (args, opts) => {
  const userId = useSelector(getAuthUserId)
  const { targetDate } = useTargetDate()
  return useGetAppointmentUtilizationQuery(
    {
      providerId: userId,
      date: targetDate,
      ...args,
    },
    opts,
  ) as RTKQueryResultType<typeof useGetAppointmentUtilizationQuery>
}
